import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import * as fromApp from './store/app.reducer';
import { catchError, switchMap, finalize, filter, first, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Router } from "@angular/router";
import * as AuthActions from './auth/store/auth.actions';
import { LoadingService } from './service/loading-service.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor(
        private store: Store<fromApp.AppState>,
        private router: Router,
        private loadingService: LoadingService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('jwt')) {
            req = req.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + localStorage.getItem('jwt'),
                },
            });
        }

        // Only track requests during initial load phase
        const isInitialLoad = this.loadingService.isInitialLoadPhase();
        if (isInitialLoad) {
            // Skip loader for certain background requests
            const skipLoader = req.url.includes('/notifications/read') ||
                req.url.includes('/heartbeat') ||
                req.url.includes('/firebase-token');

            if (!skipLoader) {
                this.loadingService.incrementInitialRequest();
            }
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    if (localStorage.getItem('jwt')) {
                        this.store.dispatch(new AuthActions.Autologin());
                        // Wait for autologin to complete before deciding to clear session
                        return this.store.select(state => state.auth).pipe(
                            filter(auth => auth?.authChecked === true),
                            first(),
                            timeout(20000),
                            switchMap(authState => {
                                if (authState?.employee) {
                                    // Session restored; keep user logged in, just propagate the failed request
                                    return throwError(() => error);
                                }
                                localStorage.removeItem('jwt');
                                localStorage.removeItem('tokenExpiration');
                                this.router.navigate(['/login']);
                                return throwError(() => error);
                            }),
                            catchError(() => {
                                // Timeout or error during auth check - clear and redirect
                                localStorage.removeItem('jwt');
                                localStorage.removeItem('tokenExpiration');
                                this.router.navigate(['/login']);
                                return throwError(() => error);
                            })
                        );
                    }
                    this.router.navigate(['/login']);
                }
                return throwError(() => error);
            }),
            finalize(() => {
                // Only track completion during initial load phase
                if (isInitialLoad) {
                    const skipLoader = req.url.includes('/notifications/read') ||
                        req.url.includes('/heartbeat') ||
                        req.url.includes('/firebase-token');

                    if (!skipLoader) {
                        this.loadingService.decrementInitialRequest();
                    }
                }
            })
        );
    }
}